import {ADMHome} from '../../view-model/admin/admhome';
import {BaseResponse} from '../internal/baseresponse';
export class ADMHomeResult extends BaseResponse {
  data: ADMHome;

}



// WEBPACK FOOTER //
// ./src/app/response/admin/admhomeresult.ts